import { useMemo, useState } from "react";
import toast from "react-hot-toast";
import api from "../../../services/api";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

function toMailto({ to, subject, body }) {
  const params = new URLSearchParams();
  if (subject) params.set("subject", subject);
  if (body) params.set("body", body);
  return `mailto:${encodeURIComponent(to)}?${params.toString()}`;
}

export default function ContactDeveloperCard() {
  const user = useMemo(() => getStoredUser(), []);

  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    if (!message.trim()) return toast.error("Please write a message.");

    const toastId = toast.loading("Sending message...");
    setSending(true);
    try {
      await api.post("/support/contact", {
        subject: subject?.trim() || "Developer contact",
        message: message.trim(),
        from: { name: user?.name, email: user?.email, role: user?.role, district: user?.district },
        to: "chisowmo@outlook.com",
      });
      toast.success("Message sent.", { id: toastId });
      setSubject("");
      setMessage("");
    } catch (err) {
      toast.error("Couldn’t send via server. Opening email composer instead.", { id: toastId });
      const body = [
        message.trim(),
        "",
        "---",
        `From: ${user?.name || "User"} (${user?.email || "no email"})`,
        `Role: ${user?.role || "—"}`,
        `District: ${user?.district || "—"}`,
      ].join("\n");
      window.location.href = toMailto({
        to: "chisowmo@outlook.com",
        subject: subject?.trim() || "VERTCORPS support",
        body,
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={send} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Subject</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="border p-2 rounded w-full focus:ring-2 focus:ring-green-600 outline-none bg-white dark:bg-gray-900 dark:border-gray-700"
            placeholder="What’s this about?"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Message</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="border p-2 rounded w-full min-h-32 focus:ring-2 focus:ring-green-600 outline-none bg-white dark:bg-gray-900 dark:border-gray-700"
            placeholder="Describe the issue or feedback..."
          />
        </div>
      </div>

      <div className="flex items-center justify-between gap-3">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          If server-side email isn’t configured, we’ll open your email app as a fallback.
        </p>
        <button
          disabled={sending}
          className={`text-xs px-4 py-2 rounded text-white font-semibold ${
            sending ? "bg-gray-400 cursor-not-allowed" : "bg-green-700 hover:bg-green-800"
          }`}
        >
          {sending ? "Sending..." : "Send"}
        </button>
      </div>
    </form>
  );
}
